import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/firebase';

/**
 * Subscribe to facilities/{facilityId} and expose its `billing` map
 * (snake_case, see A1). Returns null when the doc or map is missing.
 * Reads are permitted for facility members by the A2 Firestore rules.
 */
export function useFacilityBilling(facilityId) {
    const [billing, setBilling] = useState(null);
    const [loading, setLoading] = useState(Boolean(facilityId));
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!facilityId) { setLoading(false); setBilling(null); return undefined; }
        setLoading(true); setError(null);
        const ref = doc(db, 'facilities', facilityId);
        const unsubscribe = onSnapshot(
            ref,
            (snap) => { setBilling(snap.exists() ? (snap.data()?.billing ?? null) : null); setLoading(false); },
            (err) => { setError(err); setLoading(false); },
        );
        return unsubscribe;
    }, [facilityId]);

    return { billing, loading, error };
}
